export default __webpack_public_path__ + "static/media/sample_2.84b424ae.png";